
jQuery(document).ready(function ($) {


	// Fixed menu size
	if (Foundation.MediaQuery.atLeast('medium')) {
		var $body = $('body');
		var $header = $('#header');

		$(window).scroll(function () {
			var scroll = $(window).scrollTop();
			if (scroll > 0) {

				//clearHeader, not clearheader - caps H
				$header.addClass("header--shrink");
				$body.addClass("sticky-header");
			} else {
				$header.removeClass("header--shrink");
				$body.removeClass("sticky-header");
			}
		});
	}

	// Mobile Menu
	$('[data-toggle-menu]').on("click", function () {
		$("nav.main-menu").toggleClass('is-open');
		$('#open-menu').toggleClass('is-active');
		$('.burger-wrapper').toggleClass('is-active');
		document.body.scrollTop = document.documentElement.scrollTop = 0;
		$(document.body).toggleClass("menu-open");
	});

	// Search Modal
	$('#searchModal').on('open.zf.reveal', function () {
		setTimeout(function () { $('#search-input-desktop').focus(); }, 1000);
	});

	// Home Page link blocks
	function homepageLinks() {
		if (Foundation.MediaQuery.atLeast('medium') && $('body').hasClass('home')) {
			$('a.pageLinkBlock').each(function () {
				var $content, $height, $title_height, bottom;

				$content = $(this).find('.pageLinkBlock__content');
				$height = $content.outerHeight();
				$title_height = $(this).find('.pageLinkBlock__header').outerHeight();
				var bottom = $height - $title_height - 35;
				$content.css('bottom', -bottom);

				$(this).hover(
					function () {
						$(this).find('.pageLinkBlock__content').css('bottom', '0px');
					}, function () {
						$(this).find('.pageLinkBlock__content').css('bottom', -bottom);
					}
				);
			});
		}
	}
	$(window).on('load', function () {
		homepageLinks();
	});

	$(window).on('resize', function () {
		homepageLinks();
	});

	// Select Replace
//	$('select').selectric({
//		arrowButtonMarkup: '<div class="select-button"></div>'
//	});

	$('.gallery-wrapper').magnificPopup({
		type: 'image',
		delegate: 'a',
		titleSrc: 'title',
		gallery: {
			enabled: true
		}
	});

	// Annual Reports
	$('#annual-report-select').on('change', function (e) {
		if ($('#annual-report-select').val() != 'null') {
			$('#annual-reports button').prop('disabled', false);
		} else {
			$('#annual-reports button').prop('disabled', true);
		}
	});
	$('#annual-reports button').on('click', function (e) {
		e.preventDefault();
		var url = $('#annual-report-select').val();
		window.open(url, '_blank');
	});

	// Quarterly Reports
	$('#quarterly-report-select').on('change', function (e) {
		if ($('#quarterly-report-select').val() != 'null') {
			$('#quarterly-reports button').prop('disabled', false);
		} else {
			$('#quarterly-reports button').prop('disabled', true);
		}
	});
	$('#quarterly-reports button').on('click', function (e) {
		e.preventDefault();
		var url = $('#quarterly-report-select').val();
		window.open(url, '_blank');
	});

	// Other Reports
	$('#other-report-select').on('change', function (e) {
		if ($('#other-report-select').val() != 'null') {
			$('#other-reports button').prop('disabled', false);
		} else {
			$('#other-reports button').prop('disabled', true);
		}
	});
	$('#other-reports button').on('click', function (e) {
		e.preventDefault();
		var url = $('#other-report-select').val();
		window.open(url, '_blank');
	});


	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
		if (jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5) {
			jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	// Smooth scrolling to anchors
	$('a[href*="#"]')
		.not('[href="#"]')
		.not('[href="#_"]')
		.click(function (event) {
			if (
				location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
				&&
				location.hostname == this.hostname
			) {
				// Figure out element to scroll to
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$('html, body').animate({
						scrollTop: target.offset().top
					}, 1000);
				}
			}
		});
});
